export default "__VITE_ASSET__BVkNDE2f__"